import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { ArrowIconWrapper, OrderItem, OrderWithArrowWrapper, ActionsWrapper } from '../cms/list/List.style';

interface MoveUpDownArrowsPropsTypes {
    moveItemUp: () => void;
    moveItemDown: () => void;
    isDisabledUp?: boolean;
    isDisabledDown?: boolean;
}

export const MoveUpDown = observer('MoveUpDown', ({ moveItemUp, moveItemDown, isDisabledUp, isDisabledDown }: MoveUpDownArrowsPropsTypes) => {
    return (
        <ActionsWrapper>
            <OrderWithArrowWrapper onClick={moveItemUp} isDisabled={isDisabledUp ?? false} data-test='move-up-icon'>
                <ArrowIconWrapper position='up' />
                <OrderItem>Up</OrderItem>
            </OrderWithArrowWrapper>
            <OrderWithArrowWrapper onClick={moveItemDown} isDisabled={isDisabledDown ?? false} data-test='move-down-icon'>
                <ArrowIconWrapper position='down' />
                <OrderItem>Down</OrderItem>
            </OrderWithArrowWrapper>
        </ActionsWrapper>
    );
});
